import React, {useRef} from 'react';
import {ScrollingBodyModal} from '@homeaway/react-modal';
import {useModalRoute} from '@homeaway/react-router-modal';

import FilterGroupFooter from '../FilterGroupFooter/FilterGroupFooter';

import {MIN_RESULTS_TO_SEARCH} from '../../utils/constants';

import {Props} from '../FilterGroupDropdown/FilterGroupDropdown';

import './FilterGroupModal.less';

export default function FilterGroupModal({
    children,
    label,
    secondaryLabel,
    groupId,
    isMobile,
    filters,
    results,
    selectedFilters,
    onDone,
    onClear,
    onDismiss,
    filterPill,
    customFiltersParams,
}: Props) {
    const [isModalOpen, setModalOpen] = useModalRoute(`filterGroup-${groupId}`);
    const isModalDismissed = useRef(false);

    function onOpenModal() {
        isModalDismissed.current = false;
        setModalOpen(true);
    }

    function handleModalClose() {
        setModalOpen(false);

        /* istanbul ignore else */
        if (!isModalDismissed.current) {
            isModalDismissed.current = true;
            if (results > MIN_RESULTS_TO_SEARCH) {
                onDone();
            } else {
                onDismiss();
            }
        }
    }

    function handleOnDone() {
        isModalDismissed.current = true;
        setModalOpen(false);
        onDone();
    }

    function renderFooter() {
        return (
            <FilterGroupFooter
                groupId={groupId}
                customFiltersParams={customFiltersParams}
                onDone={handleOnDone}
                onClear={onClear}
                results={results}
                filters={filters}
                selectedFilters={selectedFilters}
            />
        );
    }

    return (
        <div className="FilterGroupModal">
            {React.cloneElement(filterPill, {
                onClick: onOpenModal,
            })}
            <ScrollingBodyModal
                id={groupId}
                isOpen={isModalOpen}
                onClose={handleModalClose}
                onModalClose={handleModalClose}
                title={label}
                footer={renderFooter()}
                parentNode={
                    /* istanbul ignore next */
                    typeof document !== 'undefined' ? document.body : null
                }
                isWorkflow={isMobile}
                portalClassName="ScrollingBodyModalPortal"
            >
                {secondaryLabel && (
                    <span className="FilterGroupModal__SecondaryLabel">
                        {secondaryLabel}
                    </span>
                )}
                {children}
            </ScrollingBodyModal>
        </div>
    );
}

export {FilterGroupModal};
